const m02Section = {
  id: 'm02',
  name: '2027ScoresheetM02Sub1Label',
  fields: [
    {
      scoring: '2027ScoresheetM02Sub2Label',
      id: 'm02_scoring_1',
      options: [
        {
            description: '0',
            value: 0
        },
        {
            description: '1',
            value: 1
        },
        {
            description: '2',
            value: 2
        },
        {
          description: '3',
          value: 3
        }
      ]
    }
  ]
}

export default m02Section;